import axios from 'axios';

import { AddressCriteria, IAddress } from '@/shared/model/address.model';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseApiUrl = 'api/adresses';

export default class AddressService {
  public find(id: number): Promise<IAddress> {
    return new Promise<IAddress>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(req?: any, criteria?: AddressCriteria): Promise<any> {
    return axios.post(`${baseApiUrl}Filter?${buildPaginationQueryOpts(req)}`, criteria);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAddress): Promise<IAddress> {
    return new Promise<IAddress>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAddress): Promise<IAddress> {
    return new Promise<IAddress>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
